module.exports = __webpack_public_path__ + "static/media/home.7f0d9ce5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/home.svg
// module id = 831
// module chunks = 21